import React from 'react';
import {
  Link, Button, IconLogo, getTranslation,
} from '@resy/ui-kitchen';
import PropTypes from 'prop-types';
import { updateLinksWithOriginB2B, handleMktAnalytics } from '../../../AmexMarketingUtils/AmexUtils';
import { CTA_EVENT_NAME } from '../../../AmexMarketingUtils/constants';

const HeaderNav = ({
  menuItems, setScrollForDirMenu, printContent, hasOriginB2B, Analytics,
}) => (
  <nav aria-label="Primary navigation desktop">
    <Button
      href="/"
      className="ResyAmexGDAHeader__resy-logo"
      variant="no-style"
      aria-label={getTranslation({
        translationKey: 'resy_logo_click_home',
        fallback: 'Resy Logo. Click to go home.',
      })}
    >
      <IconLogo height="30" width="68" />
    </Button>
    <ul className="ResyAmexGDAHeader__nav">
      {menuItems && menuItems.map((menuItem, index) => {
        const { link } = menuItem;
        return (
          <li key={menuItem.id}>
            {(!menuItem.id || menuItem.id === '') && printContent(menuItem.id, 'id')}
            {(!menuItem.link || menuItem.link === '') && printContent(menuItem.link, 'link')}
            {(menuItem.internal === undefined || menuItem.internal === null || menuItem.internal === '') && printContent(menuItem.internal, 'internal')}
            {menuItem.internal
              ? (
                <Button
                  variant="no-style"
                  className="ResyAmexGDAHeader__nav--button"
                  data-test-id={`amexgda_home_page-header-navigation-item${index}`}
                  type="button"
                  onClick={async () => {
                    await setScrollForDirMenu(link);
                    const extraParam = {
                      action_name: 'Menu - Click',
                      item_name: menuItem.text,
                    };
                    handleMktAnalytics(Analytics.event, CTA_EVENT_NAME, extraParam);
                  }}
                >
                  {printContent(menuItem.text, 'text')}
                </Button>
              )
              : (
                <Link
                  href={updateLinksWithOriginB2B(link, hasOriginB2B)}
                  onClick={() => {
                    if (link.includes('global-dining-access-partner-page')) {
                      const extraParam = {
                        action_name: 'Menu - Click',
                        item_name: 'GDA Partner Overview',
                      };
                      handleMktAnalytics(Analytics.event, CTA_EVENT_NAME, extraParam);
                    }
                  }}
                >
                  {printContent(menuItem.text, 'text')}
                </Link>
              )}
          </li>
        );
      })}
    </ul>
    {menuItems.length === 0 && printContent(menuItems, 'menuItems')}
  </nav>
);

HeaderNav.propTypes = {
  menuItems: PropTypes.arrayOf(PropTypes.object).isRequired,
  setScrollForDirMenu: PropTypes.func.isRequired,
  printContent: PropTypes.func.isRequired,
  hasOriginB2B: PropTypes.bool.isRequired,
  Analytics: PropTypes.shape({
    event: PropTypes.func,
  }).isRequired,
};

export default HeaderNav;
